module.exports = __webpack_public_path__ + "img/003.8fbc7d44.png";